
export type UpdateEnrollmentProgressBody = {
  /** 완료한 레슨 ID 목록 */
  completedLessonIds?: string[];
  /** 완료한 모듈 ID 목록 */
  completedModuleIds?: string[];
  /**
   * 진행률 (%)
   * @minimum 0
   * @maximum 100
   */
  progressPercentage: number;
};
